export default __webpack_public_path__ + "static/media/img (1).9493fe77.jpg";